<div class="card-base">
  <div class="card-content-reservation-search">
      <div class="chip-container">
          <mat-chip-list>
              <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                  {{ filt.valueView }}
                  <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
              </mat-chip>
          </mat-chip-list>
      </div>
      <div class="card-container mat-elevation-z1">
          <div class="clearfix">
              <div class="pull-left div-header-left">
                  <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                  <app-medical-appointment-wait-filter #filters></app-medical-appointment-wait-filter>
              </div>
          </div>
          <mat-divider></mat-divider>

          <div class="card-content margin-botton-medium">
              <p-scrollPanel styleClass="scroll-panel">
                  <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                      <ng-container matColumnDef="date">
                          <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
                              <resizable-column-control width="150" tile="Fecha" #resColFecha></resizable-column-control>
                          </th>
                          <td class="search-table-cell" mat-cell *matCellDef="let element">
                              <div><b>{{ element.Date |  date: 'dd/MM/yyyy'}}</b></div>
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="dateContact">
                        <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
                            <resizable-column-control width="150" tile="Fecha pref." #resColFecha></resizable-column-control>
                        </th>
                        <td class="search-table-cell" mat-cell *matCellDef="let element">
                            <div><b>{{ element.DateContact }}</b></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="timeContact">
                      <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
                          <resizable-column-control width="150" tile="Hora pref." #resColFecha></resizable-column-control>
                      </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let element">
                          <div><b>{{ element.TimeContact }}</b></div>
                      </td>
                  </ng-container>
                      <ng-container matColumnDef="patientFullName">
                          <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                              <resizable-column-control width="150" tile="Paciente" #resColPatient></resizable-column-control>
                          </th>
                          <td class="search-table-cell" mat-cell *matCellDef="let element">
                              <div >{{ element.PatientFullName }}</div>
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="patientCelPhone">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="50" tile="Celular" #resColPatient></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div >{{ element.PatientCelPhone }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="stateName">
                                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                    <resizable-column-control width="50" tile="Estado" #resColPatient></resizable-column-control>
                                </th>
                                <td class="search-table-cell" mat-cell *matCellDef="let element">
                                    <div >{{ element.StateName }}</div>
                                </td>
                            </ng-container>

                      <ng-container matColumnDef="serviceName">
                        <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                            <resizable-column-control width="150" tile="Servicio" #resColPractice></resizable-column-control>
                        </th>
                        <td  class="search-table-cell" mat-cell *matCellDef="let element">
                            <div>{{ element.ServiceName }}</div>
                        </td>
                    </ng-container>

                      <!-- Star Column -->
                      <ng-container matColumnDef="star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                    <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>
                                <button mat-icon-button  *ngIf="!element.Loading" [matMenuTriggerFor]="menuItem">
                                <mat-icon>more_vert</mat-icon>
                      </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item (click)="startReservationWizard(element)"><mat-icon>add</mat-icon><span>Generar turno</span></button>
                                    <button mat-menu-item (click)="viewTrace(element)"><mat-icon>search</mat-icon><span>Seguimiento</span></button>
                                    <button mat-menu-item (click)="openPatientViewDialog(element)"><mat-icon>perm_identity</mat-icon><span>Ver paciente</span></button>
                                </mat-menu>
                            </td>
                        </ng-container>
                      <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
              </p-scrollPanel>
              <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
          </div>
      </div>
  </div>
</div>
